var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-association"},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',{staticClass:"content-box",staticStyle:{"font-size":"16px","line-height":"22px"},domProps:{"innerHTML":_vm._s(_vm.context)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }